import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IStartPageInfoProps } from "../types";
import Link from "next/link";

export const StartPageInfo = ({ isDefaultLanguage }: IStartPageInfoProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <ul className="p-3 space-y-2 border rounded-lg bg-white list-disc list-inside">
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_A}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_H}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_B}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_C}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_D}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_E}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_F}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_G}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_I}</Typography>
        <Link href="/funds" className="text-blueHighlighted">
          her
        </Link>
      </li>
    </ul>
  );
};
